import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import LanguageSwitcher from "./LanguageSwitcher";

/**
 * Public navigation — visible to visitors.
 * Admin Technique is NEVER shown here (only reachable via /admin URL for
 * users with admin / super-admin role).
 */
export default function PublicNav() {
  const { user, isAdmin, logout } = useAuth();
  const { t } = useTranslation();

  return (
    <nav className="afr-nav" data-testid="afr-public-nav">
      <Link to="/" className="afr-nav__brand" data-testid="nav-brand-home">
        <span className="afr-mark" aria-hidden="true">
          <img src="/brand/africtal-logo.png" alt="AFRICTAL" />
        </span>
        <span className="afr-brand-text">AFRICTAL</span>
        <span className="afr-tag">{t("nav.brand_tag")}</span>
      </Link>

      <div className="afr-nav__links">
        <NavLink to="/" end data-testid="nav-link-accueil">{t("nav.home")}</NavLink>
        <NavLink to="/ecosystemes" data-testid="nav-link-ecosystemes">{t("nav.ecosystems")}</NavLink>
        <NavLink to="/solutions" data-testid="nav-link-solutions">{t("nav.solutions")}</NavLink>
        <NavLink to="/a-propos" data-testid="nav-link-about">{t("nav.about")}</NavLink>
        <NavLink to="/#faq" data-testid="nav-link-faq">{t("nav.faq")}</NavLink>

        <LanguageSwitcher compact />

        {user ? (
          <>
            <Link
              to="/dashboard"
              className="afr-btn afr-btn--outline afr-btn--sm"
              data-testid="nav-btn-dashboard"
            >
              {t("nav.my_space")}
            </Link>
            {isAdmin && (
              <Link
                to="/admin"
                className="afr-btn afr-btn--ghost afr-btn--sm"
                data-testid="nav-btn-admin"
              >
                {t("nav.admin_technical")}
              </Link>
            )}
            <button
              className="afr-btn afr-btn--ghost afr-btn--sm"
              onClick={logout}
              data-testid="nav-btn-logout"
            >
              {t("nav.logout")}
            </button>
          </>
        ) : (
          <>
            <Link
              to="/login"
              className="afr-btn afr-btn--outline afr-btn--sm"
              data-testid="nav-btn-login"
            >
              {t("nav.login")}
            </Link>
            <Link
              to="/login?mode=signup"
              className="afr-btn afr-btn--primary afr-btn--sm"
              data-testid="nav-btn-signup"
            >
              {t("nav.signup")}
            </Link>
          </>
        )}
      </div>
    </nav>
  );
}
